<template>
  <el-dialog title="管理专业" :visible.sync="visible" width="60%" @close="resetForm">
    <div class="bind-skill-content">
      <div class="staff-info">
        <el-tag type="info">员工：{{ currentStaff.name }}</el-tag>
        <el-tag type="info" style="margin-left: 10px">手机号：{{ currentStaff.tel }}</el-tag>
      </div>

      <div class="skill-tree" v-loading="loading">
        <el-tree
          ref="skillTree"
          :data="skillTreeData"
          show-checkbox
          node-key="id"
          :props="{ label: 'name', children: 'children' }"
          :default-checked-keys="checkedKeys"
          :default-expand-all="false"
          :check-strictly="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <el-tag v-if="data.categoryType == 1" type="primary" size="mini" style="margin-right: 5px">
                专业技能
              </el-tag>
              {{ node.label }}
            </span>
            <!-- 隐藏二级分类的多选框 -->
            <span v-if="data.categoryType != 1 && data.categoryType !== '1'" class="checkbox-placeholder"></span>
          </span>
        </el-tree>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listRepairCategories } from '@/api/work/skillApi'
import { updateUserSignPic, getUserCategorys } from '@/api/user/userInfoApi'

export default {
  name: 'BindStaffSkill',
  data() {
    return {
      visible: false,
      loading: false,
      submitLoading: false,
      currentStaff: {},
      skillTreeData: [],
      checkedKeys: []
    }
  },
  methods: {
    async show(staff) {
      this.currentStaff = staff
      this.visible = true
      await this.loadSkills()
      await this.loadStaffSkills()
    },
    async loadSkills() {
      this.loading = true
      try {
        const { data } = await listRepairCategories({ status: 1 })
        
        // 构建树形结构
        const firstLevel = data.filter(item => item.categoryType == 1 || item.categoryType === '1')
        this.skillTreeData = firstLevel.map(item => ({
          id: item.id,
          name: item.name,
          categoryType: item.categoryType,
          children: (item.childrenCategories || []).map(child => ({
            id: child.id,
            name: child.name,
            categoryType: child.categoryType
          }))
        }))
      } catch (error) {
        this.$message.error(error.message || '加载技能列表失败')
      } finally {
        this.loading = false
      }
    },
    async loadStaffSkills() {
      if (!this.currentStaff.userId) return
      
      try {
        const res = await getUserCategorys({ userId: this.currentStaff.userId })
        // 返回的可能是逗号分隔的字符串或数组，需要处理
        let categoryIds = []
        
        if (res.data) {
          if (typeof res.data === 'string') {
            // 如果是逗号分隔的字符串，转换为数组
            categoryIds = res.data.split(',').filter(id => id.trim() !== '').map(id => id.trim())
          } else if (Array.isArray(res.data)) {
            categoryIds = res.data
          } else if (res.data.categoryIds) {
            // 如果返回的是对象，包含categoryIds字段
            const ids = res.data.categoryIds
            if (typeof ids === 'string') {
              categoryIds = ids.split(',').filter(id => id.trim() !== '').map(id => id.trim())
            } else if (Array.isArray(ids)) {
              categoryIds = ids
            }
          }
        }
        
        // 将字符串ID转换为数字ID（如果需要）
        const firstLevelIds = categoryIds.map(id => {
          const numId = typeof id === 'string' ? parseInt(id, 10) : id
          return isNaN(numId) ? id : numId
        })
        
        this.checkedKeys = firstLevelIds
        
        // 延迟设置选中状态，确保树已渲染
        this.$nextTick(() => {
          if (this.$refs.skillTree && this.checkedKeys.length > 0) {
            this.$refs.skillTree.setCheckedKeys(this.checkedKeys)
          }
        })
      } catch (error) {
        // 如果接口不存在或失败，checkedKeys 保持为空数组
                console.warn('查询员工技能失败', error)
        this.checkedKeys = []
      }
    },
    async submit() {
      if (!this.$refs.skillTree) {
        this.$message.warning('请选择技能')
        return
      }

      const checkedKeys = this.$refs.skillTree.getCheckedKeys()
      
      // 只获取一级分类（专业技能）的ID
      const firstLevelIds = checkedKeys.filter(key => {
        return this.skillTreeData.some(parent => parent.id === key)
      })

      if (firstLevelIds.length === 0) {
        this.$message.warning('请至少选择一个专业技能')
        return
      }

      // 将一级分类ID数组转换为逗号分隔的字符串
      const categoryIds = firstLevelIds.join(',')

      this.submitLoading = true
      try {
        await updateUserSignPic({
          userId: this.currentStaff.userId,
          categoryIds: categoryIds
        })
        this.$message.success('绑定技能成功')
        this.$emit('success')
        this.visible = false
      } catch (error) {
        this.$message.error(error.message || '绑定技能失败')
      } finally {
        this.submitLoading = false
      }
    },
    resetForm() {
      this.currentStaff = {}
      this.skillTreeData = []
      this.checkedKeys = []
      if (this.$refs.skillTree) {
        this.$refs.skillTree.setCheckedKeys([])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-skill-content {
  .staff-info {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .skill-tree {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }
}

// 完全隐藏二级分类节点，只显示一级分类
::v-deep .el-tree-node {
  .el-tree-node__children {
    display: none !important;
  }
  
  // 隐藏展开/折叠箭头
  .el-tree-node__expand-icon {
    display: none !important;
  }
  
  // 隐藏展开图标占位空间
  .el-tree-node__content {
    padding-left: 8px !important;
  }
}
</style>


